import { render } from "./ToolbarSeparator.vue?vue&type=template&id=96561404"
import script from "./ToolbarSeparator.vue?vue&type=script&lang=js"
export * from "./ToolbarSeparator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__